import "../../../styles/input.scss";

import PropTypes from "prop-types";
import React from "react";

export const tagTypes = {
    red: "tag-red",
    grey: "tag-grey",
    green: "tag-green"
};

export class Tag extends React.PureComponent {
    constructor(props){
        super(props);
        
    }

    render() {
        const {
            className,
            label,
            type,
            onClickTag,
        } = this.props;
        return(
            <div className={`${type} ${className}` } onClick={onClickTag} >
                <div className="tag-text" >
                    {label}
                </div>
            </div>
        );
    }
}

Tag.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClickTag: PropTypes.func,
};